export default __webpack_public_path__ + "static/media/logoPE.14cccb18.png";